module.exports = __webpack_public_path__ + "img/exam_result.13878766.svg";